import { get, post, del, put } from "../../utils/axiosInstance";

const BASE_URL = "/rest/inventory";

export const fetchPurchaseOrders = (page, purchaseOrderId = null, vendor = null, status = null, date = null) => {
  let url = `${BASE_URL}/purchase_orders/?page=${page}`;
  if (purchaseOrderId) url += `&id=${purchaseOrderId}`;
  if (vendor) url += `&vendor=${vendor}`;
  if (date) url += `&date=${date}`;
  if (status) url += `&status=${status}`;
  return get(url);
};

export const fetchPurchaseOrderDetail = (id) => {
  const url = `${BASE_URL}/purchase_orders/${id}/`;
  return get(url);
};

export const createPurchaseOrder = (data) => {
  const url = `${BASE_URL}/purchase_orders/`;
  return post(url, data);
};

export const addItemToPurchaseOrder = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/add_item/`;
  return post(url, data);
};

export const deleteItemFromPurchaseOrder = (id) => {
  const url = `${BASE_URL}/purchase_order_items/${id}/`;
  return del(url);
};

export const updateItemInPurchaseOrder = (id, data) => {
  const url = `${BASE_URL}/purchase_order_items/${id}/`;
  return put(url, data);
};

export const awaitPurchaseOrder = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/await_purchase_order/`;
  return post(url, data);
};

export const associatePurchaseOrderInvoice = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/associate_invoice/`;
  return post(url, data);
};

export const createPurchaseOrderItemLabel = (id, barcode, plant, price, weight, packingDate, vendorLotNumber, repeat) => {
  const url = `${BASE_URL}/purchase_order_items/${id}/create_label/`;
  return post(url, { barcode, plant, price, weight, packingDate, vendorLotNumber, repeat });
};

export const deletePurchaseOrderItemLabel = (id, labelId) => {
  const url = `${BASE_URL}/purchase_order_items/${id}/delete_label/`;
  return post(url, { labelId });
};

export const completePurchaseOrder = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/complete_purchase_order/`;
  return post(url, data);
};

export const finishPurchaseOrder = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/finish_purchase_order/`;
  return post(url, data);
};

export const duplicatePurchaseOrder = (id) => {
  const url = `${BASE_URL}/purchase_orders/${id}/duplicate/`;
  return post(url);
};

export const deletePurchaseOrder = (id) => {
  const url = `${BASE_URL}/purchase_orders/${id}/delete/`;
  return del(url);
};

export const changePurchaseOrderInvoiceNumber = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/change_invoice_number/`;
  return post(url, data);
};

export const changePurchaseOrderInvoiceAmount = (id, data) => {
  const url = `${BASE_URL}/purchase_orders/${id}/change_invoice_amount/`;
  return post(url, data);
};
